import { shallowMount } from "@vue/test-utils";
import EmailField from "@/components/core/EmailField";

describe("EmailField Component mount", () => {
  let wrapper;

  beforeEach(() => {
    wrapper = shallowMount(EmailField);
  });

  it("Renders del component EmailField", () => {
    expect(wrapper).toBeDefined();
  });
});
